import { ChipProps } from '@mui/material';

import { OfferingFilterChip } from './OfferingFilterChip';

export const PropertyTypeFilterChip = ({ sx, ...rest }: ChipProps) => {
  return (
    <OfferingFilterChip
      sx={{
        '&.MuiChip-root': {
          height: 'auto',
          minWidth: '75px',
          maxWidth: '120px',
        },
        '.MuiChip-label': { p: 1 },
        ...sx,
      }}
      {...rest}
    />
  );
};
